module.exports = __webpack_public_path__ + "img/PT980492491.3765f42e.png";